import { render, staticRenderFns } from "./SettingTermsOfService.vue?vue&type=template&id=2f4fe51e"
import script from "./SettingTermsOfService.vue?vue&type=script&lang=js"
export * from "./SettingTermsOfService.vue?vue&type=script&lang=js"
import style0 from "./SettingTermsOfService.vue?vue&type=style&index=0&id=2f4fe51e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports